import { useState } from 'react';
import { useTracking } from '@podiumhq/tracking';

import { useCreditCardContext } from 'contexts/CreditCardDetailsContextProvider';
import {
  getPostalCodeErrorMessage,
  getTargetValue,
  isPostalCode,
} from 'lib/fieldValidation';

import { CANADIAN_COUNTRY_CODE, US_COUNTRY_CODE } from '../../BusinessDetails';

import { POSTAL_CODE_ID } from '../constants';

const usePostalCodeInput = ({
  trackOnBlurPath,
  zipCodeLabel = 'Billing Postal Code',
}) => {
  const id = POSTAL_CODE_ID;
  const {
    creditCardFields = {},
    setZip,
    updateCreditCardField,
  } = useCreditCardContext() || {};
  const postalCodeFields = creditCardFields[id];
  const { trackEvent } = useTracking();

  const [errorMessage, setErrorMessage] = useState(null);

  const updateInvalidPostalCodeField = (isInvalid) => {
    if (updateCreditCardField) {
      const updatedFields = { ...postalCodeFields, isInvalid };
      updateCreditCardField(id, updatedFields);
    }
  };

  const onBlur = (event) => {
    const postalCode = getTargetValue(event);

    if (!postalCode) {
      return setErrorMessage(null);
    }

    const isValid =
      isPostalCode(postalCode, US_COUNTRY_CODE) ||
      isPostalCode(postalCode, CANADIAN_COUNTRY_CODE);
    const isInvalid = !isValid;

    if (isValid) {
      setZip(postalCode);
      setErrorMessage(null);
    } else {
      setErrorMessage(getPostalCodeErrorMessage());
    }

    updateInvalidPostalCodeField(isInvalid);

    trackOnBlurPath && trackEvent(`${trackOnBlurPath}.postalCodeFieldFilled`);
  };

  const zipCodeText =
    zipCodeLabel === 'Billing Postal Code' ? 'ZIP / Postal' : 'ZIP';

  const postalCodeToolTipOptions = {
    id: 'postal-code',
    tipText: `Enter the ${zipCodeText} code of your credit card’s billing address.`,
  };

  return { onBlur, errorMessage, postalCodeToolTipOptions, zipCodeText };
};

export default usePostalCodeInput;
